<div class="navigation-blocker-dialog-container">
    <ng-container [ngTemplateOutlet]="data.template"></ng-container>
</div>
